<template>
  <v-btn icon density="compact" variant="text" @click="editItem">
    <v-icon icon="fas fa-pen-to-square" size="small" color="primary"></v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "EditButton",
  methods: {
    editItem() {
      this.$emit("click");
    },
  },
};
</script>
